import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Home from "./Home";
import Account from "./Account";
// import Shows from "./Shows";
// import DynamicPage from "./DynamicPage";
// import SandBox from "./SandBox";
// import SandBoxBee from "./SandBoxBee";
import NoMatch from "./NoMatch";
import { IntlProvider } from "react-intl";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import axios from "axios";
import Spanish from "../lang/es.json";
import English from "../lang/en.json";
import Portuguese from "../lang/pt.json";
import Login from "./Login";
import SignupForm from "./SignupForm";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Help from "./Help";
import Products from "./Products";
import Pricing from "./Pricing";
import Preferences from "./Preferences";
import Shop from "./Shop";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import PrivateRoute from "./PrivateRoute";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

axios.defaults.withCredentials = true;

const App = () => {
  const languageMap = {
    es: Spanish,
    "es-ar": Spanish,
    "es-mx": Spanish,
    pt: Portuguese,
    "pt-br": Portuguese,
    "pt-pt": Portuguese,
    // otros idiomas...
  };

  const locale = navigator.language.toLowerCase();
  const langCode = locale.split("-")[0]; // obtiene 'pt' de 'pt-br'
  const lang = languageMap[locale] || languageMap[langCode] || English;

  const [user, setUser] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState(null);
  const [loading, setLoading] = useState(true); // Añadir estado de carga
  const [alert, setAlert] = useState(null);

  const updateUserState = (payload) => {
    setUser(payload);
  };
  const updateBreadcrumbsState = (object) => {
    setBreadcrumbs(object);
  };
  const updateAlertState = (object) => {
    setAlert(object);
  };

  // useEffect hook with an empty dependency array means this effect will only run once, like componentDidMount
  useEffect(() => {
    getUser();
  }, []);

  function getUser() {
    if (!user) {
      axios
        .get("/api/test/user/")
        .then((response) => {
          if (response.data.id) {
            updateUserState(response.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          updateUserState(null);
          setLoading(false);
        });
    }
    return user;
  }

  function GameWrapper() {
    window.location.replace("/game");
    return null;
  }

  if (loading) {
    return <div>Cargando...</div>; // Muestra un loader mientras carga
  }

  return (
    <AppContext.Provider
      value={{
        user,
        updateUserState,
        updateBreadcrumbsState,
        breadcrumbs,
        alert,
        updateAlertState,
      }}
    >
      <IntlProvider locale={locale} messages={lang}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/terms" element={<Terms />} />
            <Route exact path="/privacy" element={<Privacy />} />
            <Route exact path="/help" element={<Help />} />
            <Route exact path="/pricing" element={<Pricing />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route exact path="/signup" element={<SignupForm />} />
            <Route
              exact
              path="/account"
              element={
                <PrivateRoute user={user}>
                  <Account />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/products"
              element={
                <PrivateRoute user={user}>
                  <Products />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/preferences"
              element={
                <PrivateRoute user={user}>
                  <Preferences />
                </PrivateRoute>
              }
            />
            <Route
              path="/shop"
              element={
                <PrivateRoute user={user}>
                  <Shop />
                </PrivateRoute>
              }
            />
            <Route element={<NoMatch />} />
          </Routes>
        </LocalizationProvider>
      </IntlProvider>
    </AppContext.Provider>
  );
};

export default App;
